import { render, staticRenderFns } from "./ConfigTabValidation.vue?vue&type=template&id=70c0f0de"
import script from "./ConfigTabValidation.vue?vue&type=script&lang=js"
export * from "./ConfigTabValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports